import { createVanIconComponent } from "./van"

const SendGift = createVanIconComponent("send-gift")
export default SendGift
